<script>
  import { supabase } from "../auth";
  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();

  export let id;
  export let date;
  export let eventToCreate = {
    name: "",
    start_date: date,
    end_date: date,
    description: "",
    user_id: supabase.auth.user().id,
  };

  export let editMode = false;

  async function handleSubmit() {
    eventToCreate.start_date = date;
    if (editMode) {
      const { data, error } = await supabase
        .from("events")
        .update([eventToCreate])
        .eq("id", id);
    } else {
      const { data, error } = await supabase
        .from("events")
        .insert([eventToCreate]);
    }
    dispatch("eventCreated");
  }
</script>

<form on:submit|preventDefault={handleSubmit} class="max-w-xl bg-gray-50">
  {#if eventToCreate.name !== ""}
    <p class="text-lg font-medium text-gray-800">Event bearbeiten</p>
  {:else}
    <p class="text-lg font-medium text-gray-800">Event erstellen</p>
  {/if}
  <div class="my-4">
    <label class="block text-sm text-gray-800" for="name">Name</label>
    <input
      class="w-full px-5 py-2 text-gray-700 bg-gray-200 rounded"
      id="name"
      name="name"
      type="text"
      required=""
      placeholder="Event Name"
      aria-label="Name"
      bind:value={eventToCreate.name}
    />
  </div>
  <div class="my-4">
    <label class="block text-sm text-gray-800" for="name">Beschreibung</label>
    <input
      class="w-full px-5 py-2 text-gray-700 bg-gray-200 rounded"
      id="description"
      name="description"
      type="textarea"
      required=""
      placeholder="Event Beschreibung"
      aria-label="Beschreibung"
      bind:value={eventToCreate.description}
    />
  </div>
  <div class="my-4">
    <label class="block text-sm text-gray-800" for="startDate"
      >Start Datum</label
    >
    <input
      class="w-full px-5 py-2 text-gray-700 bg-gray-200 rounded"
      id="startDate"
      type="datetime-local"
      aria-label="startDate"
      bind:value={date}
    />
  </div>
  <div class="my-4">
    <label class="block text-sm text-gray-800" for="startDate">End Datum</label>
    <input
      class="w-full px-5 py-2 text-gray-700 bg-gray-200 rounded"
      id="endDate"
      type="datetime-local"
      aria-label="endDate"
      bind:value={eventToCreate.end_date}
    />
  </div>
  <div class="mt-4">
    <button
      class="w-full py-3 mt-6 text-white rounded-md bg-gradient-to-r from-fcred to-white focus:outline-none hover:bg-gray-700 hover:shadow-none"
      type="submit"
      >{editMode ? "Speichere die Änderungen" : "Speichere dein Event"}</button
    >
  </div>
</form>

<style type="text/scss">
  form {
    input[type="datetime"] {
      color: black;
    }
  }
</style>
